import { render, staticRenderFns } from "./CommonVideoPlayerDialog.vue?vue&type=template&id=5f569183&scoped=true&"
import script from "./CommonVideoPlayerDialog.vue?vue&type=script&lang=ts&"
export * from "./CommonVideoPlayerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CommonVideoPlayerDialog.vue?vue&type=style&index=0&id=5f569183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f569183",
  null
  
)

export default component.exports